export enum EMeteo {
    Ensoleille = 1,
    FaiblementNuageux,
    TempsHumide,
    PluieFine,
    OragePluieForte,
    Neige,
    Gel,
    FortementNuageux,
    ConditionsCrepusculaires
}
